<template>
  <div style="height: 100%; width: 100%;">
    <iframe
      v-if="latLng && latLng.lat && latLng.lng"
      :src="mapUrl"
      frameborder="0"
      style="border:0;width: 100%;height: 100%;"
    ></iframe>
    <div v-else>
      Invalid coordinates.
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleMapIframe",
  props: {
    latLng: {
      type: Object,
      required: true,
      validator: val =>
        val &&
        typeof val.lat === 'number' &&
        typeof val.lng === 'number'
    }
  },
  computed: {
    mapUrl() {
      // Embedding a Google Map URL (public, no API key required for basic display).
      return `https://maps.google.com/maps?q=${this.latLng.lat},${this.latLng.lng}&z=15&output=embed`;
    }
  }
};
</script>

<style scoped>
/* Optional: Style tweaks if needed */
</style>
